














































































































import Vue from 'vue';
import store from '@/store';
import _ from 'lodash';
import Draggable from 'vuedraggable';
import PropertyListing from './property-listing.vue';
import ButtonToggle from '@/components/common/button-toggle.vue';
import { Constants } from "@/api-constants";
import { API } from "aws-amplify";
import { getModule } from "vuex-module-decorators";
import FavouritesModule from "@/store/Favourites";

export default Vue.extend({

  name: 'PropertyResultsCardList',

  components: {
    'draggable': Draggable,
    'button-toggle': ButtonToggle,
    'property-listing': PropertyListing,
  },

  props: {
    choiceProp: {
      type: Object,
      default: {} as any,
    },
    choiceScoresProp: {
      type: Object,
      default: {} as any,
    },
    favouritesProp: {
      type: Array,
      default: [] as any,
    },
    favouritesFlag: {
      type: Boolean,
      default: false,
    },
    changeSortProp: {
      type: String,
      default: 'rank',
    },
    targetFactorGroupName: {
      type: String,
      default: '',
    },
    targetViewpointId: {
      type: Number,
      default: 1,
    },
    targetSumWeight: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      dialog: true,
      choice: this.choiceProp,
      originalChoice: this.choiceProp,
      favourites: this.favouritesProp,
      erroredGet: false,
      erroredPost: false,
      factorGroupName: 'Lifestyle',
      changeRank: false,
    };
  },

  created() {
  },

  mounted() {
  },

  updated() {
  },

  watch: {
    favouritesProp(newVal, oldVal) {
      this.favourites = newVal;
    },
    choiceProp(newVal, oldVal) {
      this.choice = newVal;
    },
  },

  computed: {
    instanceId(): string {
      return this.$store.getters.getInstanceId;
    },
    addressTextAlign(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md':
          return '';
        default:
          return 'text-right';
      }
    },
    brokerTextAlign(): string {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return '';
        default:
          return 'text-left';
      }
    },
  },

  methods: {

    findIndex(choice: any): number {
      const res = 1 + this.choice.findIndex((i: any) => i.id === choice.id);
      return res;
    },

    dragStart() {
      // this.dragging = true;
    },

    dragEnd() {
      // this.dragging = false;
      // this.recalculateFactorWeights();
    },

    isFavourite(choiceId: string): boolean {
      return this.favourites.includes(choiceId);
    },

    async addFavourite(choiceId: string) {
      await getModule(FavouritesModule).addFavourite(choiceId);
    },

    async removeFavourite(choiceId: string) {
      await getModule(FavouritesModule).removeFavourite(choiceId);
    },

    getPropertyValue(choice: any, name: string) {
      return choice[_.camelCase(name)]
    },

    formatNumber(value: number, digits: number = 0) {
      if (digits < 0) digits = 0;
      var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      });
      return Number(formatter.format(value));
    },

  },

});

